export default "__VITE_ASSET__DJuYCT7m__"